import cx from "classnames";

import { Card } from "ui/Card";
import { useI18n } from "utils/with-i18n.utils";

type ReasonProps = {
  reasonNumber: number;
  title: string;
  descriptionPart1: string;
  descriptionPart2: string;
};

export const Reason = ({
  descriptionPart1,
  descriptionPart2,
  reasonNumber,
  title,
}: ReasonProps) => {
  const i18n = useI18n();

  return (
    <div
      className={cx(
        "inline-flex relative w-4/5 lg:basis-[30%] my-10 mx-2 lg:mx-0 lg:my-0 lg:grow lg:max-w-sm flex-col",
        reasonNumber !== 2 ? "lg:mb-6" : "lg:self-end",
      )}
    >
      <p className="absolute -top-3 z-30 self-center h-6 text-lg font-semibold bg-yellow -rotate-3 lg:text-xl">
        {i18n.t(title)}
      </p>
      <Card
        border="filled"
        className="flex flex-col gap-y-4 justify-between p-7"
      >
        <span>{i18n.t(descriptionPart1)}</span>
        <span className="font-semibold">{i18n.t(descriptionPart2)}</span>
      </Card>
    </div>
  );
};
